// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R4UYgoVSuSZOc5Ij6lDd {
  padding: 5px 0;
}

.TaKEMk4aoPZ1BN1DBRKm {
  color: var(--grey-color-60);
  margin-top: 4px;
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  line-height: 20px; /* 142.857% */
}

.C7ftPfTcNqhmE303e7dw {
  font-size: 16px;
  font-family: var(--font-stack-full-medium);
  font-weight: 400;
  line-height: 24px;
}

.iLhee11jbe3sgJkcv3WU {
  font-size: 14px;
  color: var(--grey-color-90);
}`, "",{"version":3,"sources":["webpack://./src/components/Autocomplete/Autocomplete.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,2BAAA;EACA,eAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,2BAAA;AACF","sourcesContent":[".autocompleteMainContainer {\n  padding: 5px 0;\n}\n\n.autocompleteDescription {\n  color: var(--grey-color-60);\n  margin-top: 4px;\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 20px; /* 142.857% */\n}\n\n.autocompleteLabel {\n  font-size: 16px;\n  font-family: var(--font-stack-full-medium);\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.closeOutlined {\n  font-size: 14px;\n  color: var(--grey-color-90);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocompleteMainContainer": `R4UYgoVSuSZOc5Ij6lDd`,
	"autocompleteDescription": `TaKEMk4aoPZ1BN1DBRKm`,
	"autocompleteLabel": `C7ftPfTcNqhmE303e7dw`,
	"closeOutlined": `iLhee11jbe3sgJkcv3WU`
};
export default ___CSS_LOADER_EXPORT___;
